import { apiRequest } from "api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CREATE_SUPPORTING_DOCUMENTS_CONFIG_TO_WORKFLOW,
  GET_SUPPORTING_DOCUMENTS_CONFIG_VY_REQUESTED_ID,
  UPLOAD_SUPPORTING_DOCS_REQUESTED_TO_WORKFLOW,
} from "./apiUrls";
import { resetSuccessFullySentTouser } from "redux/dashBoardDetailReducer";

export const getSupportingDocumentsConfig = createAsyncThunk(
  "supportingDocuments/getSupportingDocumentsConfig",
  async (data) => {
    const req = GET_SUPPORTING_DOCUMENTS_CONFIG_VY_REQUESTED_ID(data);
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options,true);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
);

export const uploadSupportingDocuments = createAsyncThunk(
  "supportingDocuments/postSupportingDocuments",
  async (data) => {
    const req = UPLOAD_SUPPORTING_DOCS_REQUESTED_TO_WORKFLOW(
      data.params.organisationId,
      data.params.subWfId,
      data.params.requestId
    );
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data.body),
    };
    try {
      const result = await apiRequest(req, options,true);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
);

export const createSupportingDocumentsConfig = createAsyncThunk(
  "supportingDocuments/createSupportingDocumentsConfig",
  async (data,{dispatch}) => {
    const req = CREATE_SUPPORTING_DOCUMENTS_CONFIG_TO_WORKFLOW;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    try {
      const result = await apiRequest(req, options,true);
      setTimeout(() => {
        dispatch(resetSuccessFullySentTouser());
      }, 3000);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
);